import { Col, Row, Timeline } from "antd";
import styled, { css } from "styled-components";

import hexToRgb from "shared/utils/hexToRgb";

export const Container = styled.div`
  margin-bottom: 2rem;

  .ant-empty-description span {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

export const Content = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textColor};

  .module-name-container {
    display: flex;
    flex-direction: column;
    width: 85%;
    margin-right: 15px;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .module-name-container span:first-child {
    margin-bottom: 0.313rem;
  }

  .progress-panel {
    display: flex;
    align-items: center;

    span {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  span,
  span.ant-progress-text {
    color: ${({ theme }) => theme.colors.textColor};
  }

  span.public-badge,
  span.public-badge::selection {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .ant-collapse {
    border: none;
    background-color: unset !important;

    .ant-collapse-item {
      .ant-collapse-header {
        display: flex;
        align-items: center;
        padding-right: 0;

        .ant-collapse-arrow {
          align-self: flex-start;
          margin-top: 0.24rem;
          left: 0;
          color: ${({ theme }) => theme.colors.textColor};
        }

        @media (max-width: 800px) {
          span.module-name-container > span {
            padding: 0 20px;
          }

          .ant-collapse-arrow {
            margin-top: 0;
          }
        }
      }
    }

    .ant-timeline-item-tail {
      height: calc(100% - 25px);
    }

    .ant-collapse-content {
      background-color: ${({ theme }) => theme.colors.modalBackgroundColor};
      border-top: none !important;

      .ant-collapse-content-box {
        padding-bottom: 0;
      }
    }

    .ant-collapse-item:last-child {
      border-bottom: none;
    }
  }

  .ant-collapse-extra {
    .ant-progress-circle {
      padding: 0;
      margin: 0;
    }

    .progress-complete {
      width: 55px;
      display: flex;
      justify-content: center;

      .ant-progress-inner {
        width: 24px !important;
        height: 24px !important;
        font-size: 9px !important;
        bottom: 0px !important;
        right: 8px !important;
        background-color: #52c41a !important;

        span {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }

  .ant-collapse-content-box {
    padding-bottom: 5px;
  }

  .ant-timeline-item-content {
    padding-bottom: 10px;
  }

  .ant-progress-status-success .ant-progress-circle {
    display: none;
  }

  .ant-collapse-content {
    background: none;
  }

  @media screen and (max-width: 600px) {
    .ant-collapse-item {
      .ant-collapse-header {
        padding-left: 0px !important;
      }
    }
  }
`;

interface ICourseLessonProps {
  assisted: boolean;
}
export const CourseLesson = styled(Timeline.Item)<ICourseLessonProps>`
  cursor: pointer;

  padding-bottom: 0px !important;

  &:hover {
    color: ${({ theme }) => `rgba(${hexToRgb(theme.colors.primary)}, 0.8)`};
  }

  .lesson-title-container {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .public-badge {
    display: flex;
    min-width: 56px;
    font-size: 12px;
    padding: 3px 6px;
    margin-left: 10px;
    border-radius: 5px;
    justify-content: center;
    background: ${({ theme }) => theme.colors.primary};

    &:hover {
      color: ${({ theme }) => theme.colors.cardBlog};
    }
  }

  .ant-timeline-item-head {
    ${({ assisted, theme }) =>
      assisted
        ? css`
            border-color: ${theme.colors.primary};
            background-color: ${theme.colors.primary};
          `
        : css`
            background-color: #fff;
          `}
  }
`;

export const ColProgress = styled(Col)`
  .ant-progress-inner {
    height: 18px;
  }

  .ant-progress-bg {
    height: 18px !important;
  }

  .ant-progress-text {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

export const SectionTitle = styled.div`
  display: flex;

  span.title {
    font-size: 20px;
  }

  .section-title-badge {
    display: flex;
    font-size: 13px;
    padding: 3px 7px;
    margin-left: 15px;
    border-radius: 8px;
    width: fit-content;
    align-items: center;
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const SpinSection = styled.div`
  display: flex;
  justify-content: center;
`;
